export class HUD {
  constructor() {
    // Crosshair (Minecraft style - simple thin cross)
    const crosshair = document.createElement('div');
    crosshair.id = 'crosshair';
    crosshair.style.cssText = `
      position: fixed;
      top: 50%; left: 50%;
      transform: translate(-50%, -50%);
      width: 22px; height: 22px;
      pointer-events: none;
      z-index: 100;
    `;
    crosshair.innerHTML = `
      <span style="position:absolute; left:10px; top:2px; width:2px; height:18px; background:white; opacity:0.7; mix-blend-mode:difference;"></span>
      <span style="position:absolute; left:2px; top:10px; width:18px; height:2px; background:white; opacity:0.7; mix-blend-mode:difference;"></span>
    `;
    document.body.appendChild(crosshair);

    // Minecraft-style debug info (top-left, F3 style)
    this.statusBar = document.createElement('div');
    this.statusBar.style.cssText = `
      position: fixed;
      top: 4px; left: 4px;
      color: white;
      font-family: 'Courier New', monospace;
      font-size: 11px;
      pointer-events: none;
      z-index: 100;
      line-height: 1.6;
      text-shadow: 2px 2px 0 #3F3F3F, -1px 0 0 #3F3F3F;
    `;
    document.body.appendChild(this.statusBar);

    // Water overlay
    this.waterOverlay = document.createElement('div');
    this.waterOverlay.style.cssText = `
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(30, 60, 150, 0.3);
      pointer-events: none;
      z-index: 50;
      display: none;
    `;
    document.body.appendChild(this.waterOverlay);

    // Vignette moved to ScreenEffects.js for dynamic day/night/cave effects
  }

  showMessage(text, duration = 3) {
    this._message = text;
    this._messageTime = duration;
  }

  update(player, fps, dt, dimensionName) {
    const mode = player.flying ? 'Volando' : (player.inWater ? 'Nadando' : (player.sprinting ? 'Corriendo' : 'Caminando'));
    const x = Math.floor(player.position.x);
    const y = Math.floor(player.position.y);
    const z = Math.floor(player.position.z);
    const dimText = dimensionName && dimensionName !== 'Mundo Principal' ? `<br><span style="color:#ff6644;">${dimensionName}</span>` : '';
    this.statusBar.innerHTML = `
      FedeWorld v1.0<br>
      ${fps || '--'} fps<br>
      XYZ: ${x} / ${y} / ${z}${dimText}<br>
      <span style="color:rgba(200,200,200,0.6);font-size:10px;">${mode}</span>
    `;

    // Message display (Minecraft action bar style - above hotbar)
    if (this._messageTime > 0) {
      this._messageTime -= dt || 0.016;
      if (!this._msgEl) {
        this._msgEl = document.createElement('div');
        this._msgEl.style.cssText = `
          position: fixed;
          bottom: 70px;
          left: 50%;
          transform: translateX(-50%);
          color: white;
          font-family: 'Courier New', monospace;
          font-size: 18px;
          pointer-events: none;
          z-index: 150;
          text-shadow: 2px 2px 0 #3F3F3F, -1px -1px 0 #3F3F3F, 1px -1px 0 #3F3F3F, -1px 1px 0 #3F3F3F;
          text-align: center;
          letter-spacing: 1px;
          transition: opacity 0.3s;
          white-space: nowrap;
        `;
        document.body.appendChild(this._msgEl);
      }
      this._msgEl.textContent = this._message;
      this._msgEl.style.opacity = this._messageTime < 0.5 ? this._messageTime * 2 : 1;
      this._msgEl.style.display = 'block';
    } else if (this._msgEl) {
      this._msgEl.style.display = 'none';
    }

    // Water overlay
    this.waterOverlay.style.display = player.inWater ? 'block' : 'none';
  }
}
